import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ICONS, LOGOS } from '../../../assets';
interface HeaderProps {
  onPress: () => void;
  headerText?: string;
  back?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onPress, back, headerText }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <HeaderContainer>
      <MenuButton onClick={onPress}>
        <Icon src={back ? ICONS.back : ICONS.menu} />
      </MenuButton>

      {headerText ? (
        <HeaderText>{headerText}</HeaderText>
      ) : (
        <LogoImage 
          src={LOGOS.main} 
          alt="Illuminate Logo" 
          onClick={handleLogoClick}
        />
      )}
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  height: ${({ theme }) => theme.header.height};
  background-color: ${({ theme }) => theme.colors.darkPurple};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing.md};
`;

const MenuButton = styled.button`
  padding: ${({ theme }) => theme.spacing.xs};
  background: none;
  border: none;
  cursor: pointer;
`;

const Icon = styled.img`
  height: 30px;
  width: 30px;
`;

const HeaderText = styled.h1`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.header.fontSize};
  margin-left: ${({ theme }) => theme.spacing.sm};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
`;

const LogoImage = styled.img`
  height: 40px;
  margin-left: ${({ theme }) => theme.spacing.sm};
  max-width: 200px;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

export default Header;
